export default {
  getSkill: (state) => state.skill,
  selectedSkillSubcompetencyIds: (state) => state.selectedSkills
    .map((s) => s.subCompetencyId),
};
